import { render } from "./ToyboxAndLava.vue?vue&type=template&id=27878293"
import script from "./ToyboxAndLava.vue?vue&type=script&lang=js"
export * from "./ToyboxAndLava.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__